(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kora-editorial-hotspots"] && !Shopify.designMode) return;
  try {
    
  const initializeKoraEditorial = (scope = document) => {
    scope.querySelectorAll('[data-kora-editorial]').forEach((section) => {
      if (section.dataset.mobileLayout !== 'carousel' || section.dataset.carouselReady === 'true') return;

      const track = section.querySelector('[data-kora-editorial-track]');
      const items = [...section.querySelectorAll('[data-kora-editorial-item]')];
      const dots = [...section.querySelectorAll('[data-kora-editorial-dot]')];
      const previous = section.querySelector('[data-kora-editorial-previous]');
      const next = section.querySelector('[data-kora-editorial-next]');

      if (!track || items.length < 2 || dots.length !== items.length || !previous || !next) return;

      section.dataset.carouselReady = 'true';
      let activeIndex = 0;
      let frame;

      const updateControls = (index) => {
        activeIndex = Math.max(0, Math.min(index, items.length - 1));
        previous.disabled = activeIndex === 0;
        next.disabled = activeIndex === items.length - 1;

        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const nearestItemIndex = () => {
        const trackCenter = track.scrollLeft + track.clientWidth / 2;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        items.forEach((item, index) => {
          const itemCenter = item.offsetLeft + item.offsetWidth / 2;
          const distance = Math.abs(itemCenter - trackCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      };

      const goTo = (index) => {
        const targetIndex = Math.max(0, Math.min(index, items.length - 1));
        const centeredPosition = items[targetIndex].offsetLeft - (track.clientWidth - items[targetIndex].offsetWidth) / 2;
        track.scrollTo({
          left: centeredPosition,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
        updateControls(targetIndex);
      };

      track.addEventListener(
        'scroll',
        () => {
          window.cancelAnimationFrame(frame);
          frame = window.requestAnimationFrame(() => updateControls(nearestItemIndex()));
        },
        { passive: true }
      );

      previous.addEventListener('click', () => goTo(activeIndex - 1));
      next.addEventListener('click', () => goTo(activeIndex + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));

      const resizeObserver = new ResizeObserver(() => updateControls(nearestItemIndex()));
      resizeObserver.observe(track);
      updateControls(0);
    });
  };

  initializeKoraEditorial();
  document.addEventListener('shopify:section:load', (event) => initializeKoraEditorial(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kora-multicolumn"] && !Shopify.designMode) return;
  try {
    
  const initializeKoraMulticolumn = (scope = document) => {
    scope.querySelectorAll('[data-kora-multicolumn]').forEach((section) => {
      if (section.dataset.mobileLayout !== 'carousel' || section.dataset.carouselReady === 'true') return;

      const track = section.querySelector('[data-kora-multicolumn-track]');
      const items = [...section.querySelectorAll('[data-kora-multicolumn-item]')];
      const dots = [...section.querySelectorAll('[data-kora-multicolumn-dot]')];
      const previous = section.querySelector('[data-kora-multicolumn-previous]');
      const next = section.querySelector('[data-kora-multicolumn-next]');

      if (!track || items.length < 2 || dots.length !== items.length || !previous || !next) return;

      section.dataset.carouselReady = 'true';
      let activeIndex = 0;
      let frame;

      const updateControls = (index) => {
        activeIndex = Math.max(0, Math.min(index, items.length - 1));
        previous.disabled = activeIndex === 0;
        next.disabled = activeIndex === items.length - 1;

        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const nearestItemIndex = () => {
        const trackCenter = track.scrollLeft + track.clientWidth / 2;
        let closestIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;

        items.forEach((item, index) => {
          const itemCenter = item.offsetLeft + item.offsetWidth / 2;
          const distance = Math.abs(itemCenter - trackCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      };

      const goTo = (index) => {
        const targetIndex = Math.max(0, Math.min(index, items.length - 1));
        track.scrollTo({
          left: items[targetIndex].offsetLeft - track.offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
        updateControls(targetIndex);
      };

      track.addEventListener(
        'scroll',
        () => {
          window.cancelAnimationFrame(frame);
          frame = window.requestAnimationFrame(() => updateControls(nearestItemIndex()));
        },
        { passive: true }
      );

      previous.addEventListener('click', () => goTo(activeIndex - 1));
      next.addEventListener('click', () => goTo(activeIndex + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));

      const resizeObserver = new ResizeObserver(() => updateControls(nearestItemIndex()));
      resizeObserver.observe(track);
      updateControls(0);
    });
  };

  initializeKoraMulticolumn();
  document.addEventListener('shopify:section:load', (event) => initializeKoraMulticolumn(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  function readHierarchyGroups(resultsList) {
    const data = resultsList.querySelector('[data-kora-hierarchy-groups]');
    if (!data) return [];

    try {
      const groups = JSON.parse(data.textContent || '[]');
      return Array.isArray(groups) ? groups : [];
    } catch (error) {
      return [];
    }
  }

  function createHierarchyHeading(title, handle) {
    const item = document.createElement('li');
    item.className = 'kora-collection-group-heading';
    const heading = document.createElement('h2');
    heading.className = 'kora-collection-group-heading__title';
    if (handle) {
      const link = document.createElement('a');
      link.href = `/collections/${handle}`;
      link.textContent = title;
      heading.append(link);
    } else {
      heading.textContent = title;
    }
    item.append(heading);
    return item;
  }

  function revealCollectionHierarchy(resultsList) {
    resultsList.removeAttribute('data-kora-hierarchy-pending');
    resultsList.setAttribute('aria-busy', 'false');
  }

  function organizeCollectionHierarchy(resultsList) {
    const groups = readHierarchyGroups(resultsList);
    const grid = resultsList.querySelector('[data-testid="product-grid"]');
    if (!groups.length || !grid) {
      revealCollectionHierarchy(resultsList);
      return;
    }
    const cards = [...grid.querySelectorAll(':scope > .product-grid__item[data-kora-collection-groups]')];
    const signature = cards.map((card) => `${card.dataset.productId || card.id}:${card.dataset.koraCollectionGroups || ''}`).join(';');
    if (grid.dataset.koraHierarchySignature === signature) {
      revealCollectionHierarchy(resultsList);
      return;
    }
    grid.dataset.koraHierarchySignature = signature;
    grid.querySelectorAll(':scope > .kora-collection-group-heading').forEach((heading) => heading.remove());
    const assigned = new Set();
    const fragment = document.createDocumentFragment();
    for (const [title, handle] of groups) {
      const matches = cards.filter((card) => !assigned.has(card) && (card.dataset.koraCollectionGroups || '').split('|').includes(handle));
      if (!matches.length) continue;
      fragment.append(createHierarchyHeading(title, handle));
      matches.forEach((card) => { assigned.add(card); fragment.append(card); });
    }
    const ungrouped = cards.filter((card) => !assigned.has(card));
    if (ungrouped.length) {
      fragment.append(createHierarchyHeading('Altri gioielli', ''));
      ungrouped.forEach((card) => fragment.append(card));
    }
    grid.append(fragment);
    requestAnimationFrame(() => revealCollectionHierarchy(resultsList));
  }

  function organizeCollectionHierarchies() {
    document.querySelectorAll('results-list[data-kora-collection-hierarchy]').forEach(organizeCollectionHierarchy);
  }

  let hierarchyUpdateQueued = false;
  const hierarchyObserver = new MutationObserver(() => {
    if (hierarchyUpdateQueued) return;
    hierarchyUpdateQueued = true;
    queueMicrotask(() => {
      hierarchyUpdateQueued = false;
      organizeCollectionHierarchies();
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      organizeCollectionHierarchies();
      hierarchyObserver.observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  } else {
    organizeCollectionHierarchies();
    hierarchyObserver.observe(document.body, { childList: true, subtree: true });
  }

  window.setTimeout(() => {
    document.querySelectorAll('results-list[data-kora-hierarchy-pending]').forEach(revealCollectionHierarchy);
  }, 2500);

  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resi_cambi_2026"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const form = root.querySelector('form');
      if (!form) return;

      const steps = [...root.querySelectorAll('[data-step]')];
      const progress = [...root.querySelectorAll('[data-progress-item]')];
      const nextButton = root.querySelector('[data-next]');
      const previousButton = root.querySelector('[data-previous]');
      const submitButton = root.querySelector('[data-submit]');
      const categorySelect = root.querySelector('[data-category-select]');
      const collectionSelect = root.querySelector('[data-collection-select]');
      const productSelect = root.querySelector('[data-product-select]');
      const currentVariantSelect = root.querySelector('[data-current-variant-select]');
      const productFilterStatus = root.querySelector('[data-product-filter-status]');
      const requestType = root.querySelector('[data-request-type]');
      const reasonSelect = root.querySelector('[data-reason-select]');
      const notesInput = root.querySelector('[data-notes]');
      const notesHelp = root.querySelector('[data-notes-help]');
      const warrantyFields = root.querySelector('[data-warranty-fields]');
      const issueDate = root.querySelector('[data-issue-date]');
      const exchangeFields = [...root.querySelectorAll('[data-exchange-field]')];
      const exceptionField = root.querySelector('[data-exception-field]');
      const exceptionInput = exceptionField?.querySelector('input');
      const deliveryInput = root.querySelector('[data-delivery-date]');
      const deadlineNotice = root.querySelector('[data-deadline-notice]');
      const deadlineStatus = root.querySelector('[data-deadline-status]');
      const summary = root.querySelector('[data-summary]');
      const requestDeclaration = root.querySelector('[data-request-declaration]');
      const submissionTimestamp = root.querySelector('[data-submission-timestamp]');
      const collectionPlaceholder = collectionSelect.options[0].cloneNode(true);
      const collectionOptions = [...collectionSelect.options].slice(1).map((option) => option.cloneNode(true));
      const productPlaceholder = productSelect.options[0].cloneNode(true);
      const productOptions = [...productSelect.options].slice(1).map((option) => option.cloneNode(true));
      let currentStep = 0;
      let isExpired = false;

      const updateNavigation = () => {
        steps.forEach((step, index) => { step.hidden = index !== currentStep; });
        progress.forEach((item, index) => {
          item.classList.toggle('is-active', index === currentStep);
          item.classList.toggle('is-complete', index < currentStep);
        });
        previousButton.hidden = currentStep === 0;
        nextButton.hidden = currentStep === steps.length - 1;
        submitButton.hidden = currentStep !== steps.length - 1;
        steps[currentStep]?.querySelector('legend')?.focus?.();
      };

      const validateStep = () => {
        const fields = [...steps[currentStep].querySelectorAll('input, select, textarea')].filter((field) => !field.disabled);
        for (const field of fields) {
          if (!field.checkValidity()) {
            field.reportValidity();
            return false;
          }
        }
        return true;
      };

      const updateCurrentVariants = () => {
        const placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = root.dataset.variantChoose;
        currentVariantSelect.replaceChildren(placeholder);
        const productOption = productSelect.options[productSelect.selectedIndex];
        if (!productSelect.value || !productOption) {
          currentVariantSelect.disabled = true;
          return;
        }
        let variants = [];
        try {
          variants = JSON.parse(productOption.dataset.variants || '[]');
        } catch {
          variants = [];
        }
        if (variants.length === 0) variants = [root.dataset.variantOther];
        [...new Set(variants)].forEach((variantTitle) => {
          const option = document.createElement('option');
          const title = variantTitle === 'Default Title' ? root.dataset.variantSingle : variantTitle;
          option.value = title;
          option.textContent = title;
          currentVariantSelect.append(option);
        });
        currentVariantSelect.disabled = false;
      };

      const updateCollections = () => {
        const category = categorySelect.value;
        const compatibleCollections = collectionOptions.filter((collectionOption) => {
          const collectionHandle = collectionOption.dataset.collectionHandle;
          if (!category) return false;
          if (collectionHandle === 'all') return true;
          return productOptions.some((productOption) => {
            return productOption.dataset.category === category && productOption.dataset.collections?.includes(`|${collectionHandle}|`);
          });
        });
        const visibleCollections = compatibleCollections.map((option) => option.cloneNode(true));
        collectionSelect.replaceChildren(collectionPlaceholder.cloneNode(true), ...visibleCollections);
        collectionSelect.disabled = category === '';
        updateProducts();
      };

      const updateProducts = () => {
        const category = categorySelect.value;
        const collectionOption = collectionSelect.options[collectionSelect.selectedIndex];
        const collection = collectionOption?.dataset.collectionHandle || '';
        const ready = category !== '' && collection !== '';
        const matchingProducts = productOptions.filter((productOption) => {
          if (!ready) return false;
          if (productOption.dataset.category === 'all') return true;
          const categoryMatches = productOption.dataset.category === category;
          const collectionMatches = collection === 'all' || productOption.dataset.collections?.includes(`|${collection}|`);
          return categoryMatches && collectionMatches;
        });
        const visibleProducts = matchingProducts.map((option) => {
          const clone = option.cloneNode(true);
          clone.hidden = false;
          return clone;
        });
        const matches = matchingProducts.filter((option) => option.dataset.category !== 'all').length;
        productSelect.replaceChildren(productPlaceholder.cloneNode(true), ...visibleProducts);
        productSelect.disabled = !ready;
        updateCurrentVariants();
        if (!ready) {
          productFilterStatus.textContent = root.dataset.filterSelectValues;
        } else if (matches === 0) {
          productFilterStatus.textContent = root.dataset.filterNoResults;
        } else {
          productFilterStatus.textContent = root.dataset.filterResults.replace('[count]', matches);
        }
      };

      const updateExchange = () => {
        const isExchange = requestType?.value === 'Cambio';
        exchangeFields.forEach((field) => {
          const input = field.querySelector('input');
          field.hidden = !isExchange;
          input.disabled = !isExchange;
          input.required = isExchange;
        });
      };

      const updateRequestRules = () => {
        const isReturn = requestType?.value === 'Reso';
        const isWarranty = requestType?.value === 'Garanzia legale - articolo difettoso o non conforme';
        const isWrongItem = requestType?.value === 'Articolo errato';
        if (reasonSelect) reasonSelect.required = isWarranty || isWrongItem;
        if (notesInput) notesInput.required = isWarranty;
        if (notesHelp) notesHelp.textContent = isWarranty ? root.dataset.notesRequiredWarranty : root.dataset.notesOptional;
        if (warrantyFields) warrantyFields.hidden = !isWarranty;
        if (issueDate) {
          issueDate.disabled = !isWarranty;
          issueDate.required = isWarranty;
        }
        if (submitButton) submitButton.textContent = isReturn ? root.dataset.returnSubmit : root.dataset.defaultSubmit;
        if (requestDeclaration) {
          requestDeclaration.value = isReturn
            ? 'Comunico in modo inequivocabile la volontà di recedere dal contratto relativo all’articolo indicato.'
            : 'Richiesta di assistenza relativa alla tipologia selezionata.';
        }
      };

      const updateDeadline = () => {
        const isReturn = requestType?.value === 'Reso';
        if (!isReturn) {
          isExpired = false;
          deadlineNotice.hidden = true;
          exceptionField.hidden = true;
          exceptionInput.disabled = true;
          exceptionInput.required = false;
          exceptionInput.checked = false;
          deadlineStatus.value = 'Termine di recesso non applicato a questa richiesta';
          return;
        }
        if (!deliveryInput.value) {
          isExpired = false;
          deadlineNotice.hidden = true;
          exceptionField.hidden = true;
          exceptionInput.disabled = true;
          exceptionInput.required = false;
          deadlineStatus.value = 'Data non inserita';
          return;
        }
        const delivery = new Date(`${deliveryInput.value}T00:00:00`);
        const deadline = new Date(delivery);
        deadline.setDate(deadline.getDate() + Number(root.dataset.returnDays || 14));
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        isExpired = today > deadline;
        deadlineNotice.hidden = !isExpired;
        exceptionField.hidden = !isExpired;
        exceptionInput.disabled = !isExpired;
        exceptionInput.required = isExpired;
        deadlineStatus.value = isExpired ? `Fuori termine dichiarato - scadenza ${deadline.toLocaleDateString('it-IT')}` : `Entro i termini dichiarati - scadenza ${deadline.toLocaleDateString('it-IT')}`;
      };

      const buildSummary = () => {
        const wanted = [
          'Nome e cognome',
          'Numero ordine',
          'Data di consegna dichiarata',
          'Tipo di richiesta',
          'Categoria',
          'Collezione',
          'Articolo',
          'Variante acquistata',
          'Variante desiderata',
          'Motivo',
          'Data in cui è stato notato il problema'
        ];
        summary.replaceChildren();
        wanted.forEach((name) => {
          const fields = [...form.querySelectorAll(`[name="contact[${name}]"]`)];
          const field = fields.find((item) => item.checked) || fields.find((item) => item.value && !item.disabled);
          if (!field?.value) return;
          let value = field.value;
          if (field.tagName === 'SELECT') value = field.options[field.selectedIndex]?.text || value;
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          term.textContent = name;
          description.textContent = value;
          summary.append(term, description);
        });
        if (notesInput?.value.trim()) {
          const term = document.createElement('dt');
          const description = document.createElement('dd');
          term.textContent = root.dataset.notesLabel;
          description.textContent = notesInput.value.trim();
          summary.append(term, description);
        }
      };

      nextButton.addEventListener('click', () => {
        if (!validateStep()) return;
        if (currentStep < steps.length - 1) currentStep += 1;
        if (currentStep === steps.length - 1) buildSummary();
        updateNavigation();
      });

      previousButton.addEventListener('click', () => {
        if (currentStep > 0) currentStep -= 1;
        updateNavigation();
      });

      categorySelect?.addEventListener('change', () => {
        updateCollections();
      });
      collectionSelect?.addEventListener('change', () => {
        updateProducts();
      });
      productSelect?.addEventListener('change', updateCurrentVariants);
      deliveryInput?.addEventListener('change', updateDeadline);
      requestType?.addEventListener('change', () => {
        updateExchange();
        updateRequestRules();
        updateDeadline();
      });
      form.addEventListener('submit', (event) => {
        if (!form.checkValidity()) {
          event.preventDefault();
          form.reportValidity();
          return;
        }
        if (submissionTimestamp) submissionTimestamp.value = new Date().toLocaleString('it-IT', { timeZone: 'Europe/Rome' });
      });

      updateNavigation();
      updateCollections();
      updateExchange();
      updateRequestRules();
      updateDeadline();
    };

    document.querySelectorAll('[data-return-wizard]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-return-wizard]').forEach(initialize);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
